import { useTheme, useMediaQuery } from '@mui/material';

export default function useResponsiveAnchor() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return isMobile ? 'bottom' : 'right';
}
